import React from "react";

import { PageClean } from "..";
import { LGPDService } from "../../services";

import { Alerta, TipoAlerta, Botao, TipoBotao } from "@intechprev/componentes-web";

import config from "../../config.json";
import { reCAPTCHA } from "../../helpers";

interface Props {
  history?: any;
}

interface State {
  erro: string;
}

export class Termos extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("termos");

  constructor(props: Props) {
    super(props);

    this.state = {
      erro: ""
    }
  }

  aceitar = async () => {
    try {
      await LGPDService.Inserir(1);
      this.props.history.push('/trocarSenhaPrimeiroAcesso');
    } catch (erro) {
      if (erro.response) {
        //await this.loginForm.current.mostrarErro(erro.response.data);
        await this.setState({ erro: erro.response.data });
      } else {
        //await this.loginForm.current.mostrarErro(erro);
        //alert("Ocorreu um erro ao processar sua requisição!");
        await this.setState({ erro });
      }
    }
  }

  recusar = async () => {
    await alert("Sem o consentimento expresso no termo, o acesso ao portal do Participante não será permitido.");
    localStorage.removeItem(`@${config.appName}:token`);
    localStorage.removeItem(`@${config.appName}:token-admin`);
    await this.props.history.push('/');
  }

  render() {
    return (
      <PageClean tamanho={550} {...this.props}>
        {this.state.erro && <Alerta tipo={TipoAlerta.danger} mensagem={this.state.erro} />}

        {!this.state.erro && <>
          <h5><b>TERMO DE CONSENTIMENTO E AUTORIZAÇÃO LIVRE, ESCLARECIDO E INEQUÍVOCO DE UTILIZAÇÃO DE DADOS PESSOAIS</b></h5>
          <p style={{ textAlign: "justify" }}>
            {"Nos termos do presente termo de consentimento e de acordo com o art. 5o, XII, da Lei 13.709/2018 – LEI GERAL DE PROTEÇÃO DE DADOS, manifesto minha livre e inequívoca autorização, pela qual concordo com a consulta e tratamento dos meus dados pessoais, financeiros e cadastrais e de meus dependentes, constantes nas bases de dados da PREVIRB – FUNDAÇÃO DE PREVIDENCIA DOS SERVIDORES DO INSTITUTO DE RESSEGUROS DO BRASIL, para que os utilize e disponibilize nos serviços previstos neste portal, relacionados aos Planos de Benefícios administrados por esta Fundação."}
          </p>

          <Botao titulo={"Li e concordo com o termo acima"} onClick={this.aceitar} block />
          <Botao titulo={"Agora não"} onClick={this.recusar} tipo={TipoBotao.light} block />
        </>}
      </PageClean>
    );
  }
}